import styled from "styled-components";
import { PageSectionHeading } from "../../../../../../CommonComponents/commonStyles";
import { GhostBackButton } from "../../../../../../CommonComponents/CTA/Buttons";
import { PoolTable, ButtonLoader } from '../../styles';
import { Col } from "antd";
import { ContainerCard } from "../../../../../../CommonComponents/FlowCard/styles";

export const FlexContainer = styled.div`
display: flex;
align-items: center;
  @media only screen and (max-width: 767px) {
    flex-wrap: ${props => props.wrapInMobile? 'wrap':'nowrap'};
    justify-content: space-between;
  }
`;

export const PageHeading = styled(PageSectionHeading)`
    padding-right: 12px;
`

export const GridDiv = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: normal;
  text-transform: capitalize;
`;

export const CustomizedFlowCard = styled.div`
  ${ContainerCard}{
    margin: 0 0 5px !important;    
  }

  .ant-card{
    .ant-card-body{
      &:after{
        display: block;
        position: relative;
        z-index: 2;
        content: '';
        height: 3px;
        width: 100%;      
      }
      .ant-card-grid{
        box-shadow: none;
        @media only screen and (max-width: 768px) {
          padding-bottom: 10px;
            min-height:71px;
        }    
        @media only screen and (max-width: 991px) {
            padding-bottom: 10px;
            min-height:83px;
          };           
       
      }
      .ant-card-grid:nth-child(1), .ant-card-grid:nth-child(2){
        border-bottom: ${props => props.total ? `solid 1px ${props.theme.border.pill}` : 'none'};   
      }
    } 
  } 
`

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row:nth-child(2n + 1) {
    background-color: ${props =>
    props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-input-number {
    width: 100% !important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-table-footer {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-bottom: solid 1px #9b9b9b;
    height: 80px;
    @media only screen and (max-width: 767px) {
      height: auto;
    }
  }
`;

export const ButtonWrapper = styled.div`
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;

export const GhostBackButtonComponent = styled(GhostBackButton)`
  > div > span {
    font-family: ${props => props.theme.fontFamily.HelveticaNeue};
    font-size: ${props => props.theme.fontSize.heading};
    font-weight: 900;
    font-style: normal;
    font-stretch: condensed;
    line-height: 1.67;
    letter-spacing: 1.1px;
  }
`;

export const AddExchangeSection = styled(Col)`
  margin: 20px 0;
`

export const AddExchangeMessage = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin: 0px 0 10px;
  color: ${props => props.theme.fontColors.primary};
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`

export const AddTransaction = styled.button`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  padding: 5px 20px;
  background: #f5f5f5;
  border: 1px solid ${props => props.theme.border.pill};
  border-radius : 5px;
  color: ${props => props.theme.fontColors.primary};
  border-radius: 18px;  
  font-size: ${props => props.theme.fontSize.secondary};
  &:hover, &:focus{
    background: #f5f5f5;
    border: 1px solid ${props => props.theme.border.pill};  
    color: ${props => props.theme.fontColors.primary};
  }
  ${({ loading }) => loading && `
    color: transparent !important;
    cursor: not-allowed;
    ${ButtonLoader}{
      display: block;
    }
  `}  
`;